export default {
    news: {
        title: "News",
        categoryAria: "News categories",
        tabs: {
            all: "All",
            game: "Game",
            skillChange: "Patch",
            box: "JX3BOX",
        },
    },
    followus: {
        title: "Follow Us",
        bilibili: {
            name: "Bilibili",
            desc: "@JX3BOX",
            alt: "Bilibili",
        },
        weibo: {
            name: "Weibo",
            desc: "@JX3BOX",
            alt: "Weibo",
        },
        douyin: {
            name: "Douyin",
            desc: "@JX3BOX",
            alt: "Douyin",
        },
        wechat: {
            name: "WeChat OA",
            desc: "@JX3BOX",
            alt: "WeChat Official Account",
            qrcodeAlt: "QR code",
            qrcodeImageAlt: "WeChat QR code",
        },
    },
    feedback: {
        title: "Feedback",
        subtitle: "Feedback Center",
    },
    posts: {
        categoryAria: "Content categories",
        more: "More >>",
        tabs: {
            all: "All",
            works: "Post",
            community: "Forum",
        },
        empty: "No content",
        anonymous: "Anonymous",
        noTitle: "Untitled",
        discussion: "Discussion",
        noContent: "No content",
        picture: "[Image]",
        reply: "Reply",
    },
    box: {
        title: "JX3BOX Matrix",
        customize: "Customize",
        save: "Save layout",
        tooltip: {
            breakLine: "Line break",
            hide: "Hide",
            show: "Show",
        },
        reset: "Reset",
        resync: "Sync",
        notify: {
            successTitle: "Success",
            syncToLocal: "Synced remote data to local",
            infoTitle: "Info",
            noRemote: "No saved settings on the server",
            resetConfirmTitle: "Confirm",
            resetConfirmText: "Reset to default order?",
            resetConfirmBtn: "OK",
            resetSuccess: "Matrix has been reset",
        },
    },
    jx3code: {
        title: "Today's Codes",
        copySuccess: "Copied",
    },
    activity: {
        subtitle: "Timeline",
        title: "Events",
        month: "{month}",
        empty: "No schedule",
        defaultName: "Untitled event",
        defaultType: "Event",
    },
    joke: {
        title: "Quote of the Day",
        anonymous: "Anonymous",
        defaultContent:
            "My master asked why I still haven't met a single living soul at level 110. I glanced at the empty guild territory and shed two silent tears.",
    },
    world: {
        bulletin: "World Bulletin",
        entry: "Enter the intelligence center",
        serversTitle: "Server Status",
        chooseServer: "Choose Server",
        state: {
            open: "Smooth",
            busy: "Busy",
            full: "Full",
            close: "Maintenance",
            unknown: "Unknown",
        },
        report: {
            baizhanMap: "Bai Zhan Map",
            celebrity: "Celebrity",
            horse: "Horse Alert",
            pet: "Lucky Pets",
            reputation: "Home Reputation",
            meirentu: "Portrait",
        },
        celebrity: {
            time: "Time",
            place: "Location",
            stage: "Stage",
            specialEvent: "Special Event · ",
            titleSuffix: {
                hxxm: "河西瀚漠",
                ylc: "伊丽川",
            },
            types: {
                qiongyew: "穹野卫",
                pifeng: "披风会",
                yuncong: "云从社",
                chutian: "楚天社",
            },
        },
        meirentu: {
            label: "Portrait · ",
            todayNo: "No portrait today",
            week: {
                sun: "Sun",
                mon: "Mon",
                tue: "Tue",
                wed: "Wed",
                thu: "Thu",
                fri: "Fri",
                sat: "Sat",
            },
        },
        baizhan: {
            divider: "Bai Zhan",
            detail: "Details",
            mapPreview: "Map Preview",
        },
        luckyPet: {
            divider: "Pets",
        },
        reputation: {
            divider: "Home Reputation",
        },
        horse: {
            notRefreshed: "Not refreshed this reset",
        },
    },
    importantMsg: {
        title: "Important Notice",
        confirm: "Got it",
    },
};

